module.exports = "<preview-child [nceid]=\"vNCEid\">\r\n</preview-child>"


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/shared/components/preview/preview-parent.component.html
// module id = ../../../../../src/app/shared/components/preview/preview-parent.component.html
// module chunks = main